import { render } from "./ActionAddInternalNotes.vue?vue&type=template&id=37de9530&scoped=true"
import script from "./ActionAddInternalNotes.vue?vue&type=script&lang=js"
export * from "./ActionAddInternalNotes.vue?vue&type=script&lang=js"

import "./ActionAddInternalNotes.vue?vue&type=style&index=0&id=37de9530&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37de9530"]])

export default __exports__